import * as yup from "yup";
import {
  type BaseType,
  type Props,
  type ValidatorSync,
  typeMismatchError,
} from "./base";

export interface BooleanType extends BaseType {
  type: "BOOLEAN";
}

export function boolean(opts?: Props<BooleanType>): BooleanType {
  return {
    ...opts,
    type: "BOOLEAN",
  };
}

export const validator: ValidatorSync<BooleanType> = (_type, options) => {
  if (options?.extendedTypesValidationsV2) {
    return handRolledValidator();
  }
  return yupValidator();
};

const yupValidator = () => {
  const schema = yup.boolean();
  return (value: unknown) => {
    schema.validateSync(value, { strict: true });
  };
};

const handRolledValidator = () => {
  return (value: unknown) => {
    const unboxed = value instanceof Boolean ? value.valueOf() : value;
    if (typeof unboxed !== "boolean") {
      throw typeMismatchError("boolean", value);
    }
  };
};
